import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { parseApiData } from "go-core/api/parseApiData";
import { LoadingContainer } from "go-core/components/Loading";
import { FILTER_SEPARATOR, NEW_WAY_TO_ENCODING_FILTER_SIGN } from "go-list/core/components/Filter/services";
import { SegmentContext } from "go-segment/context";
import useDashboardContext from "../services/hooks/useDashboardContext";
import { useDashboardSegment } from "../services/hooks/useDashboardSegment";
import { DASHBOARD_RESOURCE_TYPE, GROUP_DASHBOARD_RESOURCE_TYPE } from "../services/segments/constants";
import { DashboardAllSegments, DashboardType } from "../services/types";
import Dashboard from "./Dashboard";

export const DashboardFetchSegments = () => {
	const { dashboardType } = useDashboardContext();
	const [segmentsFetched, setSegmentsFetched] = useState(false);
	const { search } = useLocation();
	const segmentContext = useContext(SegmentContext);
	const { parseSegmentsAndUpdateSegmentState, applySegmentToDashboardState, nonDefaultSegmentSetAsDefault } =
		useDashboardSegment();
	const { addFlash } = useFlash();

	const getDashboardSegments = async () => {
		try {
			const segmentfilterValues =
				dashboardType === DashboardType.GROUP_ORGANIZATIONS
					? GROUP_DASHBOARD_RESOURCE_TYPE
					: DASHBOARD_RESOURCE_TYPE;
			const filter = `resource_type|e=${segmentfilterValues}${FILTER_SEPARATOR}list_name|e=${segmentfilterValues}`;
			const fetchedSegments = await parseApiData(
				segmentContext.api().getSegments({
					f: btoa(unescape(encodeURIComponent(`${NEW_WAY_TO_ENCODING_FILTER_SIGN}${filter}`))),
				})
			);
			const parsedSegments = parseSegmentsAndUpdateSegmentState(fetchedSegments);

			const urlSearchParams = new URLSearchParams(search);
			const sParam = urlSearchParams.get("s");

			let segmentToBeSelected: DashboardAllSegments | undefined;

			if (sParam) {
				segmentToBeSelected = parsedSegments.find((segment) => segment.slug === sParam);
			} else if (nonDefaultSegmentSetAsDefault(parsedSegments)) {
				segmentToBeSelected = nonDefaultSegmentSetAsDefault(parsedSegments);
			} else {
				segmentToBeSelected = parsedSegments.find((segment) => segment.slug === "default");
			}

			if (!segmentToBeSelected) return;

			applySegmentToDashboardState(segmentToBeSelected);
			setSegmentsFetched(true);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	useEffect(() => {
		getDashboardSegments();
	}, []);

	if (!segmentsFetched) {
		return <LoadingContainer />;
	}

	return <Dashboard />;
};
